var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "jp_w" }, [
    _c(
      "div",
      { staticClass: "banner" },
      [
        _c(
          "div",
          { staticClass: "s_w" },
          [
            _c("Search", {
              attrs: { type: 1 },
              on: { toSsearch: _vm.toSsearch },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("Nav", { staticClass: "nav", attrs: { num: 2 } }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mainContent" },
      [
        _c("Menus", {
          attrs: { menusList: _vm.menusList },
          on: {
            curLable: function ($event) {
              return _vm.chooseList(arguments)
            },
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "courseL",
          },
          [
            _vm.list.length > 0
              ? _c(
                  "div",
                  { staticClass: "list" },
                  _vm._l(_vm.list, function (item) {
                    return _c(
                      "div",
                      { staticClass: "listItem" },
                      [_c("CourseItem", { attrs: { type: 8, item: item } })],
                      1
                    )
                  }),
                  0
                )
              : _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "50px",
                      "text-align": "center",
                    },
                  },
                  [_c("img", { attrs: { src: _vm.$store.getters.noData } })]
                ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "paginationX" },
              [
                _vm.total > 0
                  ? _c("el-pagination", {
                      attrs: {
                        background: "",
                        "current-page": _vm.query.pageNum,
                        "page-size": _vm.query.pageSize,
                        layout: "total, sizes, prev, pager, next, jumper",
                        "pager-count": 5,
                        total: _vm.total,
                      },
                      on: {
                        "current-change": _vm.handleCurrentChange,
                        "size-change": _vm.handleSizeChange,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }